import { createContext, useContext } from "react";
import type { LAYOUT, SIZES } from "../utils/constant";

export interface FormContextValue {
  labelWidth?: string | number;
  layout?:
    | typeof LAYOUT.HORIZONTAL
    | typeof LAYOUT.VERTICAL
    | typeof LAYOUT.INLINE;
  size?: typeof SIZES.LG | typeof SIZES.SM | typeof SIZES.MD;
}

const FormContext = createContext<FormContextValue>({});

export const FormContextProvider = FormContext.Provider;

export const FormContextConsumer = FormContext.Consumer;

export function useForm() {
  return useContext(FormContext);
}

export default FormContext;
